exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0d803da4] .el-collapse-item__content{padding:0}[data-v-0d803da4] .text-right{display:none}", ""]);

// exports
